export function normalizePhone(value) {
  const input = String(value || '').trim()
  const compact = input.replace(/[\s().-]/g, '')
  return compact.startsWith('00') ? `+${compact.slice(2)}` : compact
}

export function isValidInternationalPhone(value) {
  const normalized = normalizePhone(value)
  if (!/^\+?[0-9]{7,15}$/.test(normalized)) return false
  return !normalized.startsWith('+0')
}
